module.exports = __webpack_public_path__ + "purplelotusflower.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/purplelotusflower.png
// module id = 883
// module chunks = 0